import { render, staticRenderFns } from "./checkout-delivery-address.vue?vue&type=template&id=2c57b68f&"
import script from "./checkout-delivery-address.vue?vue&type=script&lang=js&"
export * from "./checkout-delivery-address.vue?vue&type=script&lang=js&"
import style0 from "./checkout-delivery-address.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports